// Video shim for web - provides a basic component that renders a placeholder
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface VideoProps {
  source: { uri?: string } | any;
  style?: any;
  paused?: boolean;
  controls?: boolean;
  resizeMode?: string;
  onLoad?: () => void;
  onError?: (error: any) => void;
  [key: string]: any;
}

const Video: React.FC<VideoProps> = ({ source, style, onError, ...props }) => {
  React.useEffect(() => {
    if (onError) {
      console.warn('Video playback not available on web. Please use a web-compatible video player.');
      onError({ error: 'Video not supported on web' });
    }
  }, [onError]);

  return (
    <View style={[styles.container, style]}>
      <Text style={styles.text}>Video playback not available on web</Text>
      {source?.uri && (
        <Text style={styles.uri} numberOfLines={1}>
          {source.uri}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#000',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  text: {
    color: '#fff',
    fontSize: 14,
    marginBottom: 8,
  },
  uri: {
    color: '#888',
    fontSize: 12,
    paddingHorizontal: 16,
  },
});

export default Video;

